import { useEffect, useState } from "react";
import { url, validCurrency } from "../utils/config";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import TextArea from "../reusable_components/TextArea";
import UploadImages from "../reusable_components/UploadImages";
import patchData from "../custom_functions/patchData";
import currency from "../utils/currency";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";



function AddServiceList({ serviceData, setServiceData, setShowModal, reload }) {
    const [formData, setFormData] = useState({});
    const [missingFields, setMissingFields] = useState([]);
    const [inputErrors, setInputErrors] = useState([]);
    const [showInputError, setShowInputError] = useState(false);
    const [images, setImages] = useState([])

    const serviceType = [
        'Battery Services',
        'Charging System Services',
        'Motor and Drivetrain Services',
        'Cooling System Services',
        'Braking System Services',
        'Electronics and Software Services',
        'HVAC System Services',
        'Tire and Wheel Services',
        'Safety System Services',
        'Exterior and Interior Services',
        'Emergency Services',
        'Other Services'
    ]
    const requiredFields = [
        'name',
        'costType',
        'serviceType',
        'shortDescription',
        'longDescription',
        (formData.costType === 'Hourly' ? 'estimatedTime' : 'estimatedCost'),
        'currency'
    ];
    const costType = ['Fixed', 'Hourly'];

    useEffect(() => {
        if (serviceData) {
            setFormData(serviceData)
        } else {
            setFormData({ currency: 'USD' })
        }
    }, [])

    async function addResource() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.shortDescription && formData.shortDescription.length > 0 &&
            formData.longDescription && formData.longDescription.length > 0 &&
            (formData.estimatedTime || formData.estimatedCost) && (formData.estimatedTime > 0 || formData.estimatedCost > 0) &&
            formData.costType && costType.includes(formData.costType) &&
            formData.serviceType && serviceType.includes(formData.serviceType) &&
            formData.currency && currency.includes(formData.currency) &&
            !inputErrors.includes('error')
        ) {
            const formdata = new FormData();
            Object.keys(formData).forEach(fd => formdata.append(fd, formData[fd]));
            images.forEach(image => formdata.append('image', image))

            postData(`${url}/services/service_list`, formdata, (error => {
                toast.error(error?.response?.data?.message, { autoClose: 3000 })
                setShowModal(false)
            }), (data) => {
                toast.success(data.message, { autoClose: 3000 })
                setShowModal(false)
                reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                    if (field.name === 'currency' && !validCurrency.includes(formData[field.name])) {
                        miss.push(field)
                    }
                })
            };

            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    async function updateResource() {
        if (
            formData.name && formData.name.length > 0 &&
            formData.shortDescription && formData.shortDescription.length > 0 &&
            formData.longDescription && formData.longDescription.length > 0 &&
            (formData.estimatedTime || formData.estimatedCost) && (formData.estimatedTime > 0 || formData.estimatedCost > 0) &&
            formData.costType && costType.includes(formData.costType) &&
            formData.serviceType && serviceType.includes(formData.serviceType) &&
            formData.currency && currency.includes(formData.currency) &&
            !inputErrors.includes('error')
        ) {
            const formdata = new FormData();
            Object.keys(formData).forEach(fd => formdata.append(fd, formData[fd]));
            images.forEach(image => formdata.append('image', image))

            patchData(`${url}/services/service_list/${formData.id}`, formdata, (error => {
                console.log(error)
                toast.error(error.response.data.message, { autoClose: 3000 })
                setServiceData()
            }), (data) => {
                toast.success(data.message, { autoClose: 3000 })
                setServiceData()
                setShowModal(false)
                reload(1 + Math.random())
            })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if (!fields.includes(field)) {
                        miss.push(field)
                    }
                })
            };
            console.log("miss", miss)
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    function updateFormData(e) {
        const { name, value } = e.target;
        var data = { ...formData };
        data[name] = value;
        setFormData(data);
    }

    return (
        <div className={modalContainer}>
            <div className="bg-white rounded-md p-8 w-2/3 h-4/5 overflow-y-auto">
                <div>
                    <div className={modalTitle}>Add New Service</div>
                    <div className="flex gap-8 mt-4">
                        <div className="flex-1">
                            <div className={label}>Service Name</div>
                            <Input
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='name'
                                placeHolder='Enter Service Name'
                                value={formData.name}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="flex-1">
                            <div className={label}>Service Type</div>
                            <Select
                                testId={'serviceType'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={serviceType}
                                className={inputStyle}
                                name='serviceType'
                                placeHolder='Service Type'
                                value={formData.serviceType}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className={label}>Short Description</div>
                    <Input
                        index={0}
                        inputErrors={inputErrors}
                        setInputErrors={setInputErrors}
                        missingFields={missingFields}
                        required={true}
                        className={inputStyle}
                        name='shortDescription'
                        type='text'
                        placeHolder='Enter Short Description'
                        value={formData.shortDescription}
                        onChange={e => updateFormData(e)}
                    />
                    <div className={label}>Long Description</div>
                    <TextArea
                        index={0}
                        inputErrors={inputErrors}
                        setInputErrors={setInputErrors}
                        missingFields={missingFields}
                        required={true}
                        className={inputStyle}
                        name='longDescription'
                        type='text'
                        placeHolder='Enter Long Description'
                        value={formData.longDescription}
                        onChange={e => updateFormData(e)}
                    />
                    <div className="flex gap-8">
                        <div className="flex-1">
                            <div className={label}>Cost Type</div>
                            <Select
                                testId={'costType'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={costType}
                                className={inputStyle}
                                name='costType'
                                placeHolder='Cost Type'
                                value={formData.costType}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="flex-1">
                            <div className={label}>{formData.costType === 'Hourly' ? 'Estimated Time (mins)' : 'Estimated Cost'}</div>
                            <Input
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name={formData.costType === 'Hourly' ? 'estimatedTime' : 'estimatedCost'}
                                type='number'
                                min={1}
                                placeHolder={`Enter Estimated ${formData.costType === 'Hourly' ? 'Time' : 'Cost'}`}
                                value={formData.costType === 'Hourly' ? formData.estimatedTime : formData.estimatedCost}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                        <div className="flex-1">
                            <div className={label}>Currency</div>
                            <Select
                                testId={'currency'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={currency}
                                className={inputStyle}
                                name='currency'
                                placeHolder='Currency'
                                validCurrency={validCurrency}
                                value={formData.currency}
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    {
                        !serviceData && <UploadImages images={images} setImages={setImages} id={'service-images'} width={'100px'} title={'Service Images'} />
                    }
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={() => { setShowModal(false); setFormData({}); setImages([]); setServiceData(null) }} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => { serviceData ? updateResource() : addResource() }} className={btnOne} name={'Submit'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {
                        showInputError && 'Please fill all the fields as directed!'
                    }
                </div>
            </div>
        </div>
    )
}

export default AddServiceList;